import { TableRow, TableCell } from '@mui/material';

import { FORTA_GRAY4 } from '../../../../utils/colors';
import { formatCurrency, usDollarFormatter } from '../../../../helpers';

export interface IInvoiceClaimDetailsTableRowData {
  datesOfService: string;
  description: string;
  claim_id: number;
  billed: number;
  amount_insurance_paid: number;
  adjustments: number;
  deductible: number;
  co_insurance: number;
  co_pay: number;
  balance: number;
  is_amount_paid_to_subscriber: boolean;
}

interface IInvoiceClaimDetailsTableRowProps {
  data: IInvoiceClaimDetailsTableRowData;
}

const InvoiceClaimDetailsTableRow = ({ data }: IInvoiceClaimDetailsTableRowProps) => {
  const {
    datesOfService,
    description,
    claim_id,
    billed,
    amount_insurance_paid,
    adjustments,
    deductible,
    co_insurance,
    co_pay,
    balance,
    is_amount_paid_to_subscriber,
  } = data;
  return (
    <TableRow key={claim_id}>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          minWidth: '200px',
          color: FORTA_GRAY4,
        }}
      >
        {datesOfService}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          color: FORTA_GRAY4,
        }}
      >
        {description}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          textAlign: 'right',
          color: FORTA_GRAY4,
        }}
      >
        {usDollarFormatter.format(billed ?? 0)}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          minWidth: '120px',
          textAlign: 'right',
          color: FORTA_GRAY4,
        }}
      >
        {formatCurrency(amount_insurance_paid, is_amount_paid_to_subscriber)}
      </TableCell>

      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          textAlign: 'right',
          color: FORTA_GRAY4,
        }}
      >
        {formatCurrency(adjustments)}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          minWidth: '120px',
          textAlign: 'right',
          color: FORTA_GRAY4,
        }}
      >
        {formatCurrency(deductible)}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          textAlign: 'right',
          color: FORTA_GRAY4,
          minWidth: '120px',
        }}
      >
        {formatCurrency(co_insurance)}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          textAlign: 'right',
          color: FORTA_GRAY4,
          minWidth: '120px',
        }}
      >
        {formatCurrency(co_pay)}
      </TableCell>
      <TableCell
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '21px',
          minWidth: '150px',
          textAlign: 'right',
          color: FORTA_GRAY4,
        }}
      >
        {formatCurrency(balance)}
      </TableCell>
    </TableRow>
  );
};

export default InvoiceClaimDetailsTableRow;
